import { NgModule }             from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LoginComponent }       from './modules/login/login.component'
import { LoginGuard }           from './modules/login/login.guard';

const mainAppRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  {
    path: 'hospitalApp',
    loadChildren: () => import('../app/modules/hospital-app/hospital-app.module').then(module => module.HospitalAppModule),
  },
  { 
    path: 'adminApp', 
    loadChildren: () => import('../app/modules/admin-app/admin-app.module').then(module => module.AdminAppModule),
  },
  {
    path: 'institutionApp',
    loadChildren: () => import('../app/modules/institution-app/institution-app.module').then(module => module.InstitutionAppModule),
  },
  { path: '**', redirectTo: 'login' }
]

@NgModule({
  imports: [
    RouterModule.forRoot(mainAppRoutes, {
      paramsInheritanceStrategy: 'always',
      enableTracing: false,
      onSameUrlNavigation: 'reload',
      useHash: true
    })
  ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}
